import { graphql } from "../graphql";

export const ORG_BY_ID_QUERY = graphql(`
  query orgById($id: Int!) {
    organisation_by_pk(id: $id) {
      needs_historical_data
      sourceBySource {
        name
        description
        alias
        source_type
      }
    }
  }
`);
